import { CssBaseline, ThemeProvider } from '@material-ui/core';
import { FunctionComponent, ReactNode } from 'react';
import { selectTheme } from './HcpMuiTheme';

type IHcpThemeProvider = {
  children: ReactNode;
};

export const HCPThemeProvider: FunctionComponent<IHcpThemeProvider> = (props) => (
  <ThemeProvider theme={selectTheme()}>
    <CssBaseline />
    {props.children}
  </ThemeProvider>
);
